import React from "react";

//Styles
import "./SeeOur.scss";

//Components
import Button from "common-components/Button/Button";
import ContestExample from "./ContestExample/ContestExample";
import RevealOnScroll from "common-components/RevealOnScroll/RevealOnScroll";

//Assets
import { ReactComponent as Line1Svg } from "assets/see-our-1.svg";
import { ReactComponent as Line2Svg } from "assets/see-our-2.svg";

function SeeOur() {
  return (
    <section className="page-langing see-our">
      <Line1Svg className="line-top" />
      <Line2Svg className="line-bottom" />
      <RevealOnScroll>
        <div className="m-width-wrapper">
          <div className="left-column">
            <h2>See our logo design contests</h2>
            <div className="button-animation-wrapper">
              <Button styleType="primary rounded">Start similar contest</Button>
            </div>
          </div>
          <div className="right-column">
            <ContestExample />
          </div>
          <div className="button-animation-wrapper">
            <Button styleType="primary rounded">Start similar contest</Button>
          </div>
        </div>
      </RevealOnScroll>
    </section>
  );
}

export default SeeOur;
